// extracted by mini-css-extract-plugin
export default {"container":"QCWvYcMbwa_RgfuOVEu5"};